import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConsumosService } from "../../servicios/consumos.service";
import { CatTipoPeriodosService } from "../../servicios/cat-tipo-periodos.service";
import { MedidoresService } from "../../servicios/medidores.service";
import { CatTipoConsumosService } from "../../servicios/cat-tipo-consumos.service";
import { CatDiametroTomasService } from "../../servicios/cat-diametro-tomas.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatTipoIngresoService } from "../../servicios/cat-tipo-ingreso.service";
import { AguasService } from "../../servicios/aguas.service";
import { CatTipoUsosService } from "../../servicios/cat-tipo-usos.service";
import { CatTipoServiciosService } from "../../servicios/cat-tipo-servicios.service";
import { CobroConceptosService } from "../../servicios/cobro-conceptos.service";
import { CatAnomaliasService } from "../../servicios/cat-anomalias.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { CargosService } from "../../servicios/cargos.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Consumos } from "../../entidades/entidades";
import { CatTipoPeriodos } from "../../entidades/entidades";
import { Medidores } from "../../entidades/entidades";
import { CatTipoConsumos } from "../../entidades/entidades";
import { CatDiametroTomas } from "../../entidades/entidades";
import { CatUsuarios } from "../../entidades/entidades";
import { CatTipoIngreso } from "../../entidades/entidades";
import { Aguas } from "../../entidades/entidades";
import { CatTipoUsos } from "../../entidades/entidades";
import { CatTipoServicios } from "../../entidades/entidades";
import { CobroConceptos } from "../../entidades/entidades";
import { CatAnomalias } from "../../entidades/entidades";
import { CatEstatus } from "../../entidades/entidades";
import { Cargos } from "../../entidades/entidades";

@Component({
  selector: "app-consumos-row",
  templateUrl: "./consumos-row.component.html",
  styleUrls: ["./consumos-row.component.css"],
})
export class ConsumosRowComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catTipoPeriodos: CatTipoPeriodos[] = [];
  medidores: Medidores[] = [];
  catTipoConsumos: CatTipoConsumos[] = [];
  catDiametroTomas: CatDiametroTomas[] = [];
  catUsuarios: CatUsuarios[] = [];
  catTipoIngreso: CatTipoIngreso[] = [];
  aguas: Aguas[] = [];
  catTipoUsos: CatTipoUsos[] = [];
  catTipoServicios: CatTipoServicios[] = [];
  cobroConceptos: CobroConceptos[] = [];
  catAnomalias: CatAnomalias[] = [];
  catEstatus: CatEstatus[] = [];
  cargos: Cargos[] = [];
  consumosForm: FormGroup;
  @Input("consumos") consumos: Consumos;
  @Output("consumosOutput") consumosOutput: EventEmitter<Consumos>;

  constructor(
    private formBuilder: FormBuilder,
    private consumosService: ConsumosService,
    private catTipoPeriodosService: CatTipoPeriodosService,
    private medidoresService: MedidoresService,
    private catTipoConsumosService: CatTipoConsumosService,
    private catDiametroTomasService: CatDiametroTomasService,
    private catUsuariosService: CatUsuariosService,
    private catTipoIngresoService: CatTipoIngresoService,
    private aguasService: AguasService,
    private catTipoUsosService: CatTipoUsosService,
    private catTipoServiciosService: CatTipoServiciosService,
    private cobroConceptosService: CobroConceptosService,
    private catAnomaliasService: CatAnomaliasService,
    private catEstatusService: CatEstatusService,
    private cargosService: CargosService,
    private route: ActivatedRoute
  ) {
    this.consumosOutput = new EventEmitter();
  }

  ngOnInit() {
    // this.getAllCatTipoPeriodos();
    // this.getAllMedidores();
    // this.getAllCatTipoConsumos();
    // this.getAllCatDiametroTomas();
    // this.getAllCatUsuarios();
    // this.getAllCatTipoIngreso();
    // this.getAllCatUsuarios();
    // this.getAllAguas();
    // this.getAllCatTipoUsos();
    // this.getAllCatTipoServicios();
    // this.getAllCobroConceptos();
    // this.getAllCatAnomalias();
    // this.getAllCatEstatus();
    // this.getAllCatUsuarios();
    // this.getAllCargos();
    this.consumosForm = this.formBuilder.group({
      id: [undefined],
      idMedidor: [undefined],
      lecturaIni: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      lecturaFin: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      consumo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      idTipoConsumo: [undefined],
      idDiametroToma: [undefined],
      idUsuarioCaptura: [undefined],
      fechaAlta: [undefined],
      idTipoPeriodo: [undefined],
      anio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      periodoIni: [undefined],
      periodoParcialidad: [
        undefined,
        [Validators.pattern(/^[0-9]+\.?[0-9]*$/)],
      ],
      periodoFin: [undefined],
      idTipoIngreso: [undefined],
      idUsuarioLecturista: [undefined],
      observaciones: [undefined, [Validators.maxLength(150)]],
      idCargo: [undefined],
      idAgua: [undefined],
      idTipoUso: [undefined],
      idTipoServicio: [undefined],
      idCobroConcepto: [undefined],
      idAnomalia: [undefined],
      idEstatus: [undefined],
      idUsuarioAsigno: [undefined],
      fechaAsignacion: [undefined],
    });
    if (this.consumos) this.consumosForm.patchValue(this.consumos);
  }

  //====================================================
  //Función de muestra.
  //====================================================
  async guardarConsumos() {
    try {
      if (this.consumosForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      this.consumos = this.consumosForm.value;

      if (this.consumos.id) {
        this.updateConsumos(this.consumos);
      } else {
        this.consumos.id = 0;
        await this.addConsumos(this.consumos);
      }
      this.consumosOutput.emit(this.consumos);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarConsumos");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addConsumos(consumos) {
    try {
      const datoretorno = await this.consumosService.add(consumos).toPromise();
      this.consumos = datoretorno;
      this.consumosForm.patchValue(this.consumos);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addConsumos");
    }
  }

  async updateConsumos(consumos: Consumos) {
    try {
      const datoRetorno = await this.consumosService
        .update(consumos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateConsumos");
    }
  }

  async deleteConsumos(consumos: Consumos) {
    try {
      const datoRetorno = await this.consumosService
        .delete(consumos.id)
        .toPromise();
      this.getAllConsumos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteConsumos");
    }
  }

  async getConsumos(id: number) {
    try {
      const datoRetorno = await this.consumosService.getSingle(id).toPromise();
      this.consumosForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getConsumos");
    }
  }

  async getAllConsumos() {
    try {
      const datoRetorno = await this.consumosService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllConsumos");
    }
  }

  async getAllCatTipoPeriodos() {
    try {
      const datoRetorno = await this.catTipoPeriodosService
        .getAll()
        .toPromise();
      this.catTipoPeriodos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPeriodos");
    }
  }

  async getAllMedidores() {
    try {
      const datoRetorno = await this.medidoresService.getAll().toPromise();
      this.medidores = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getMedidores");
    }
  }

  async getAllCatTipoConsumos() {
    try {
      const datoRetorno = await this.catTipoConsumosService
        .getAll()
        .toPromise();
      this.catTipoConsumos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoConsumos");
    }
  }

  async getAllCatDiametroTomas() {
    try {
      const datoRetorno = await this.catDiametroTomasService
        .getAll()
        .toPromise();
      this.catDiametroTomas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatDiametroTomas");
    }
  }

  async getAllCatUsuarios() {
    try {
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuarios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  async getAllCatTipoIngreso() {
    try {
      const datoRetorno = await this.catTipoIngresoService.getAll().toPromise();
      this.catTipoIngreso = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoIngreso");
    }
  }

  async getAllAguas() {
    try {
      const datoRetorno = await this.aguasService.getAll().toPromise();
      this.aguas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAguas");
    }
  }

  async getAllCatTipoUsos() {
    try {
      const datoRetorno = await this.catTipoUsosService.getAll().toPromise();
      this.catTipoUsos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoUsos");
    }
  }

  async getAllCatTipoServicios() {
    try {
      const datoRetorno = await this.catTipoServiciosService
        .getAll()
        .toPromise();
      this.catTipoServicios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoServicios");
    }
  }

  async getAllCobroConceptos() {
    try {
      const datoRetorno = await this.cobroConceptosService.getAll().toPromise();
      this.cobroConceptos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCobroConceptos");
    }
  }

  async getAllCatAnomalias() {
    try {
      const datoRetorno = await this.catAnomaliasService.getAll().toPromise();
      this.catAnomalias = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatAnomalias");
    }
  }

  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  async getAllCargos() {
    try {
      const datoRetorno = await this.cargosService.getAll().toPromise();
      this.cargos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCargos");
    }
  }
}
